import { render, staticRenderFns } from "./OnboardingStepLeadStatuses.vue?vue&type=template&id=3f3d1e6d&scoped=true&"
import script from "./OnboardingStepLeadStatuses.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepLeadStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3d1e6d",
  null
  
)

export default component.exports